var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Links } from ".";
import { BackgroundStyle } from "../utils/constraints";
import { useDateTime } from "../utils/hooks";
export var Background = function (_a) {
    var imgURL = _a.imgURL, style = _a.style;
    var videoProperties = {
        key: imgURL,
        style: __assign(__assign({}, BackgroundStyle.video), style),
        id: "main-video",
        className: "tk-background"
    };
    if (imgURL.match(/\.mp4$/))
        return React.createElement("video", __assign({}, videoProperties, { muted: true, loop: true, autoPlay: true }),
            React.createElement("source", { src: imgURL }));
    return React.createElement("img", { key: imgURL, id: "main-image", className: "tk-background", src: imgURL, style: __assign({ width: "100%" }, style) });
};
export var MappedImage = function (props) {
    var _a = props.imageURL, imageURL = _a === void 0 ? "" : _a, imageFunction = props.imageFunction, imageStyle = props.imageStyle, children = props.children;
    // useDateTime() refreshes every minute.
    // We don't actually care what the current dateTime is,
    //  we just use this to trigger a redraw of the component
    useDateTime("minute");
    var image = imageURL || imageFunction();
    return React.createElement("div", { key: image, className: "tk-mapped-image", style: { position: "relative" } },
        React.createElement(React.Fragment, null,
            React.createElement(Background, { imgURL: image, style: imageStyle }),
            props.links && props.links.length > 0 ? React.createElement(Links, { links: props.links, roomName: props.roomName || "" }) : null,
            children));
};
//# sourceMappingURL=Mappings.js.map